import { IBrickInstanceTargetingAction } from 'src/app/store/utility/IBrickInstanceTargetingAction';
import { DirectoryEntryRemoteDto } from 'src/generated/swagger';

export class SelectedSubscriberChanged implements IBrickInstanceTargetingAction {
   public static readonly type = '[Selected Subscriber] Selected Subscriber Changed';
   constructor(public selectedSubscriber: DirectoryEntryRemoteDto, public brickInstanceId: string) {}
}
